/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const FreeshipCouponListPage = lazyLoad(
  () => import('./index'),
  module => module.FreeshipCouponListPage
);
